<template>
  <div v-if="ready" class="feature">
    <FeatureMeta :feature="featureStore.feature" />

    <div v-if="featureStore.images.length === 0">
      <FeatureInitSection include-uploader :feature="featureStore.feature" :intro-count="3" :sample-count="4" />
      <PageRemoveBackground />
    </div>

    <div v-else class="h-full">
      <LayoutDefault show-cost :total-cost="totalCost" @finished="onFinished">
        <template #aside>
          <form>
            <fieldset :disabled="featureStore.processing" class="flex flex-col space-y-6">
              <div class="flex flex-col space-y-2">
                <label for="mode" class="input-label">Mode</label>
                <div class="flex space-x-4 items-center">
                  <label
                    v-for="mode in [
                      ['Fast', 'fast'],
                      ['Quality', 'quality'],
                    ]"
                    :key="mode[1]"
                    class="w-1/2 input-label icon-option flex space-x-2 items-center justify-center"
                    :class="{ 'icon-option--pro': mode[1] === 'quality' }"
                    :for="`mode_${mode[1]}`"
                  >
                    <input
                      :id="`mode_${mode[1]}`"
                      v-model="featureStore.options['remove-background'].mode"
                      class="radio"
                      :value="mode[1]"
                      type="radio"
                    />
                    <span>{{ mode[0] }}</span>
                  </label>
                </div>
              </div>
            </fieldset>
          </form>
        </template>
      </LayoutDefault>
    </div>
  </div>

  <div v-else class="feature-loader">
    <img src="@/images/system/loader.gif" alt="Loader" />
  </div>
</template>

<script setup lang="ts">
  import { useFeatureSetup } from '$/composables/useFeatureSetup'
  import { useCostCalculate } from '$/composables/useCostCalculate'
  import PageRemoveBackground from '&/landing_pages/PageRemoveBackground.vue'
  import FeatureMeta from '&/FeatureMeta.vue'

  const {
    ready,
    router,
    slug,
    featureStore,
    watchRestrictedOption,
    watchTaskOptions,
    LayoutDefault,
    FeatureInitSection,
  } = useFeatureSetup()
  const { totalCost } = useCostCalculate()

  function onFinished() {
    router.push({ name: 'RemoveBackgroundResult' })
  }

  watchRestrictedOption(slug, 'mode', 'quality', 'quality_mode')
  watchTaskOptions()
</script>
